// extracted by mini-css-extract-plugin
export default {"Main":"PageParrainage_Main__Izt6Y","SurfacePopUp":"PageParrainage_SurfacePopUp__4VJih","Header":"PageParrainage_Header__BBVVx","BoutonAjouter":"PageParrainage_BoutonAjouter__HaH29"};